<template>
  <NuxtLink
    v-if="to"
    :to="to"
    v-bind="$attrs"
    :class="btnVariant"
    :target="
      target || (typeof to === 'string' && isExternalUrl(to))
        ? '_blank'
        : '_self'
    "
  >
    <slot />
    <Component :is="'icon-' + icon" v-if="icon" :class="iconClasses" />
  </NuxtLink>
  <button v-else :class="btnVariant" v-bind="$attrs" type="button">
    <slot />
    <Component :is="'icon-' + icon" v-if="icon" :class="iconClasses" />
  </button>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    to: string | object | null
    target?: string
    icon?: string
    variant?: 'secondary' | 'primary'
    iconClasses?: string
  }>(),
  {
    variant: 'primary',
    iconClasses: 'w-5 ml-3 transition-transform group-hover:translate-x-1',
  },
)

const btnVariant = computed(() => {
  const classes = [
    'flex items-center transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed',
  ]

  if (props.variant === 'primary') {
    classes.push(
      'bg-Blue-Primary hover:bg-Blue-Secondary text-White py-2.5 px-10 rounded-full text-p1 w-max group',
    )
  }

  if (props.variant === 'secondary') {
    classes.push(
      'bg-Blue-Secondary hover:bg-Blue-Primary text-White py-2 md:py-2.5 px-10 w-max rounded-full group',
    )
  }

  return classes
})
</script>
